const e = {
  name: "AngledRight",
  dimensions: { width: 17, height: 14 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.92 8.62C15.87 8.5 15.8 8.39 15.7 8.29L11.7 4.29C11.31 3.9 10.68 3.9 10.29 4.29C9.9 4.68 9.9 5.31 10.29 5.7L12.58 7.99H3C2.45 7.99 2 7.54 2 6.99V1C2 0.45 1.55 0 1 0C0.45 0 0 0.45 0 1V7C0 8.66 1.34 10 3 10H12.59L10.3 12.29C9.91 12.68 9.91 13.31 10.3 13.7C10.69 14.09 11.32 14.09 11.71 13.7L15.71 9.7C15.8 9.61 15.88 9.5 15.93 9.37C16.03 9.13 16.03 8.85 15.93 8.61L15.92 8.62Z" fill="currentColor"/>
    `
};
export {
  e as AngledRight
};
